import { Typography } from '@material-ui/core';

/** Campaign-rows alignment: 1 aligned, 0 misaligned, 2 matched, -1 not matched */
export function CampaignAlignmentBadge({ code }: { code: number | undefined }) {
  const n =
    code === undefined || Number.isNaN(Number(code)) ? undefined : Number(code);

  if (n === 1) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#039855', fontSize: 12 }}
      >
        Aligned
      </Typography>
    );
  }
  if (n === 0) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#B42318', fontSize: 12 }}
      >
        Misaligned
      </Typography>
    );
  }
  if (n === 2) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#039855', fontSize: 12 }}
      >
        Matched
      </Typography>
    );
  }
  if (n === -1) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#667085', fontSize: 12 }}
      >
        Not matched
      </Typography>
    );
  }

  return (
    <Typography
      component='span'
      variant='caption'
      style={{ fontWeight: 600, color: '#B42318', fontSize: 12 }}
    >
      Misaligned
    </Typography>
  );
}
